<template>
  <div class="modal-backdrop pt-5">
    <div class="modal dark-panel w-auto h-auto" style="margin-left: 33.33%; margin-top:3%">
      <header class="modal-header">
        <slot name="header">
          <h1>{{trans.get('common.infocustomer')}}</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>

      <div class="modal-body">
        <slot name="body">
            <form id="editClientForm" method='post' enctype='multipart/form-data' :action="routesubmit">
                <input type="hidden" name="_token" v-bind:value="csrf">
                <div class="row">               
                    <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                        <div class="input-group">
                            <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                <h5>{{trans.get("common.name")}}</h5>
                            </div>
                            <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                                <input type="text" class="form-control" :placeholder="trans.get('common.name')" aria-describedby="basic-addon1" name="name" :value="clientname"/>
                            </div>
                        </div>
                        <br/>
                        <div class="input-group">
                            <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                <h5>{{trans.get("common.contact")}}</h5>
                            </div>
                        </div>
                        <br/>
                        <div class="input-group">
                            <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                <h5>{{trans.get("common.lastname")}}</h5>
                            </div>
                            <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                                <input type="text" class="form-control" :placeholder="trans.get('common.lastname')" aria-describedby="basic-addon1" name="last_name_contact" :value="contactlastname"/>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                <h5>{{trans.get("common.firstname")}}</h5>
                            </div>
                            <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                                <input type="text" class="form-control" :placeholder="trans.get('common.firstname')" aria-describedby="basic-addon1" name="first_name_contact" :value="contactfirstname"/>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                <h5>Mail</h5>
                            </div>
                            <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                                <input type="text" class="form-control" placeholder="Mail" aria-describedby="basic-addon1" name="mail_contact" :value="contactmail"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1">

                        <div class="input-group">

                            <div class="col-md-12 ml-sm-0 col-lg-12 pt-1 px-1 pl-5">
                                <!--<div class="dropzone" ondragenter="dragenter(event)" name="file" files="true"  ondragover="dragover(event)" ondrop="drop(event)">-->
                                <label for='inputImg' class="preview" >
                                    <input id="inputImg" type="file" name="logo" class="inputImg preview" style="opacity: 0" @change="readURL(this)" />
                                    <img id="imageLogo" class="underInput" :src="logoPath"/>
                                    <div id="texteimgdrop">
                                        <span class="glyphicon glyphicon-open"></span>
                                        <h5 class="textDrop">{{trans.get('common.dropimage')}}</h5>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>  
                </div>
                <div class="row pt-4">
                    <button type="submit" class="btn btn-primary buttonOriginal text-blue_claire" style="margin-left:47%">
                        <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                    </button>
                </div>
            </form>
        </slot>
       </div>

      <footer class="modal-footer">
        <button type="button" class="btn btn-primary text-blue_claire" @click="close">
          {{trans.get('common.cancel')}}
        </button>
      </footer>
  </div>
</div>
</template>


<script>

export default {
    name: "clientInfoModal",
    props : ['clientid','clientname', 'contactfirstname', 'contactlastname', "contactmail", "logo" , 'routesubmit'],     
    data : function(){
        return {
            logoPath :"",
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },
    mounted: function(){
        if(this.logo != null && this.logo != '') {
            this.logoPath = "/images/" + this.logo;
        } else {
            this.logoPath = "#";
        }
    },
    methods :{
        close() {
            this.$emit('close');
        },
        readURL(input) {
            if (input.files && input.files[0]) {
                document.getElementById('imageLogo').style.visibility = "visible";
                var reader = new FileReader();
                reader.onload = function (e) {
                $('#imageLogo')
                    .attr('src', e.target.result);
                };
                document.getElementById('texteimgdrop').style.visibility = "collapse";
                reader.readAsDataURL(input.files[0]);
            }
        }
    }
}

</script>

<style>
</style>